import React, { useEffect, useState, useRef } from 'react';
import { motion, useAnimationControls } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon, PauseIcon, PlayIcon } from 'lucide-react';
interface PostCard {
  id: number;
  image?: string;
  gradient: string;
  tag: string;
  likes: string;
}
const posts: PostCard[] = [{
  id: 1,
  image: 'https://cdn.magicpatterns.com/uploads/hYjZfXgLo6SM2QHotNYa4r/WhatsApp-Image-2026-06-16-at-10.13.26-AM-2.jpg',
  gradient: 'linear-gradient(135deg, #050505 0%, #1a1000 50%, #C9A84C22 100%)',
  tag: '#MKON_U',
  likes: '2.4K'
}, {
  id: 2,
  image: 'https://cdn.magicpatterns.com/uploads/hSWnpgTNWXUStkM74BQLiY/WhatsApp-Image-2026-06-16-at-10.13.26-AM-1.jpg',
  gradient: 'linear-gradient(135deg, #0a0005 0%, #1a0010 50%, #C9A84C15 100%)',
  tag: 'ROOFTOP VIBES',
  likes: '1.8K'
}, {
  id: 3,
  image: 'https://cdn.magicpatterns.com/uploads/u4Z2hegvp1qu6b9BJNhzru/WhatsApp-Image-2026-06-16-at-10.13.25-AM.jpg',
  gradient: 'linear-gradient(135deg, #050a00 0%, #0a1500 50%, #C9A84C20 100%)',
  tag: 'VIP ONLY',
  likes: '3.1K'
}, {
  id: 4,
  image: 'https://cdn.magicpatterns.com/uploads/2DziDyxptDKwZmZD2Ba3sW/WhatsApp-Image-2026-06-16-at-10.13.26-AM-5.jpg',
  gradient: 'linear-gradient(135deg, #050505 0%, #201500 50%, #E8C97A18 100%)',
  tag: 'BOTTLE SERVICE',
  likes: '2.9K'
}, {
  id: 5,
  image: 'https://cdn.magicpatterns.com/uploads/cjyMK2vPP2Vh454pzcm18J/WhatsApp-Image-2026-06-16-at-10.13.24-AM.jpg',
  gradient: 'linear-gradient(135deg, #000510 0%, #001020 50%, #C9A84C25 100%)',
  tag: '#DCNIGHTLIFE',
  likes: '4.2K'
}, {
  id: 6,
  image: 'https://cdn.magicpatterns.com/uploads/jSqknTPXsEQuDczoieZ1Kv/WhatsApp-Image-2026-06-16-at-10.13.25-AM-2.jpg',
  gradient: 'linear-gradient(135deg, #100005 0%, #200010 50%, #C9A84C18 100%)',
  tag: 'SATURDAY VIBES',
  likes: '1.5K'
}, {
  id: 7,
  image: 'https://cdn.magicpatterns.com/uploads/9iBGPPPDtc9rMCeCuJsaeK/WhatsApp-Image-2026-06-16-at-10.13.25-AM-4.jpg',
  gradient: 'linear-gradient(135deg, #050505 0%, #150a00 50%, #C9A84C30 100%)',
  tag: 'GOLD HOUR',
  likes: '3.7K'
}, {
  id: 8,
  image: 'https://cdn.magicpatterns.com/uploads/taRUXEm7G7W1bgNVU3GzZ2/WhatsApp-Image-2026-06-16-at-10.13.26-AM.jpg',
  gradient: 'linear-gradient(135deg, #000a05 0%, #001510 50%, #C9A84C20 100%)',
  tag: 'LATIN NIGHTS',
  likes: '2.2K'
}, {
  id: 9,
  image: 'https://cdn.magicpatterns.com/uploads/6CwKL9L7jBsScN6pyF43ZJ/WhatsApp-Image-2026-06-16-at-10.13.26-AM-4.jpg',
  gradient: 'linear-gradient(135deg, #0a0500 0%, #1a0a00 50%, #E8C97A22 100%)',
  tag: '#MKON_U',
  likes: '1.9K'
}, {
  id: 10,
  image: 'https://cdn.magicpatterns.com/uploads/wYrsf19kY92pmXJgWmbs8c/WhatsApp-Image-2026-06-16-at-10.13.25-AM-8.jpg',
  gradient: 'linear-gradient(135deg, #050010 0%, #0a0020 50%, #C9A84C15 100%)',
  tag: 'INDUSTRY SUNDAYS',
  likes: '2.6K'
}, {
  id: 11,
  image: 'https://cdn.magicpatterns.com/uploads/u4Z2hegvp1qu6b9BJNhzru/WhatsApp-Image-2026-06-16-at-10.13.25-AM.jpg',
  gradient: 'linear-gradient(135deg, #100500 0%, #201000 50%, #C9A84C28 100%)',
  tag: 'VIP SECTION',
  likes: '3.3K'
}, {
  id: 12,
  image: 'https://cdn.magicpatterns.com/uploads/hSWnpgTNWXUStkM74BQLiY/WhatsApp-Image-2026-06-16-at-10.13.26-AM-1.jpg',
  gradient: 'linear-gradient(135deg, #050505 0%, #0a0a00 50%, #E8C97A20 100%)',
  tag: 'SKYBOX SUITE',
  likes: '4.8K'
}];
const CARD_WIDTH = 220;
const CARD_GAP = 16;
const CARD_TOTAL = CARD_WIDTH + CARD_GAP;
export function InstagramWall() {
  const [isPaused, setIsPaused] = useState(false);
  const scrollRef = useRef<HTMLDivElement>(null);
  const positionRef = useRef(0);
  const animFrameRef = useRef<number>(0);
  const lastTimeRef = useRef<number>(0);
  const SPEED = 0.18; // px per ms
  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;
    const totalWidth = posts.length * CARD_TOTAL;
    const animate = (timestamp: number) => {
      if (!lastTimeRef.current) lastTimeRef.current = timestamp;
      const delta = timestamp - lastTimeRef.current;
      lastTimeRef.current = timestamp;
      if (!isPaused) {
        positionRef.current += SPEED * delta;
        if (positionRef.current >= totalWidth) {
          positionRef.current -= totalWidth;
        }
        el.scrollLeft = positionRef.current;
      }
      animFrameRef.current = requestAnimationFrame(animate);
    };
    animFrameRef.current = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(animFrameRef.current);
  }, [isPaused]);
  const scrollLeft = () => {
    positionRef.current = Math.max(0, positionRef.current - CARD_TOTAL);
    if (scrollRef.current) scrollRef.current.scrollLeft = positionRef.current;
  };
  const scrollRight = () => {
    positionRef.current += CARD_TOTAL;
    if (scrollRef.current) scrollRef.current.scrollLeft = positionRef.current;
  };
  // Duplicate posts for seamless loop
  const displayPosts = [...posts, ...posts, ...posts];
  return <section id="gallery" className="w-full bg-[#050505] py-16 overflow-hidden" style={{
    touchAction: 'pan-y'
  }} data-id="element-325">
      <div className="max-w-7xl mx-auto px-6" data-id="element-326">
        {/* Header row */}
        <div className="flex items-end justify-between mb-8" data-id="element-327">
          <div data-id="element-328">
            <motion.h2 initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} className="font-montserrat font-black text-3xl sm:text-4xl tracking-widest text-white mb-1" data-id="element-329">
              FOLLOW THE VIBE
            </motion.h2>
            <motion.a initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.1
          }} href="https://instagram.com/mk_on_u" target="_blank" rel="noopener noreferrer" className="font-inter text-sm text-[#C9A84C] hover:text-[#E8C97A] transition-colors" data-id="element-330">
              @mk_on_u
            </motion.a>
          </div>

          {/* Controls */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="flex items-center gap-3" data-id="element-331">
            <button onClick={scrollLeft} className="w-8 h-8 flex items-center justify-center border border-[#C9A84C]/40 text-[#C9A84C] rounded-full hover:border-[#C9A84C] hover:bg-[#C9A84C]/10 transition-all duration-300" aria-label="Scroll left" data-id="element-332">
              <ChevronLeftIcon size={14} data-id="element-333" />
            </button>
            <button onClick={scrollRight} className="w-8 h-8 flex items-center justify-center border border-[#C9A84C]/40 text-[#C9A84C] rounded-full hover:border-[#C9A84C] hover:bg-[#C9A84C]/10 transition-all duration-300" aria-label="Scroll right" data-id="element-334">
              <ChevronRightIcon size={14} data-id="element-335" />
            </button>
            <button onClick={() => setIsPaused(p => !p)} className="w-8 h-8 flex items-center justify-center border border-[#C9A84C]/40 text-[#C9A84C] rounded-full hover:border-[#C9A84C] hover:bg-[#C9A84C]/10 transition-all duration-300" aria-label={isPaused ? 'Play' : 'Pause'} data-id="element-336">
              {isPaused ? <PlayIcon size={12} data-id="element-337" /> : <PauseIcon size={12} data-id="element-338" />}
            </button>
          </motion.div>
        </div>
      </div>

      {/* Scrolling strip */}
      <div ref={scrollRef} className="flex gap-4 overflow-x-hidden no-scrollbar pl-6" style={{
      cursor: 'grab',
      touchAction: 'pan-y'
    }} data-id="element-339">
        {displayPosts.map((post, i) => <motion.div key={`${post.id}-${i}`} whileHover={{
        scale: 1.03
      }} transition={{
        type: 'spring',
        stiffness: 300,
        damping: 20
      }} className="flex-shrink-0 rounded-xl overflow-hidden relative group cursor-pointer" style={{
        width: CARD_WIDTH,
        height: CARD_WIDTH,
        background: post.gradient
      }} data-id="element-340">
            {/* Actual image */}
            {post.image && <img src={post.image} alt={post.tag} className="absolute inset-0 w-full h-full object-cover" data-id="element-341" />}

            {/* Gold shimmer overlay */}
            <div className="absolute inset-0 bg-gradient-to-br from-[#C9A84C]/5 via-transparent to-[#C9A84C]/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-342" />

            {/* Instagram grid lines removed as requested */}

            {/* Tag */}
            <div className="absolute bottom-0 left-0 right-0 p-3 bg-gradient-to-t from-black/80 to-transparent" data-id="element-343">
              <p className="font-montserrat font-700 text-xs tracking-widest text-[#C9A84C]" data-id="element-344">
                {post.tag}
              </p>
              <p className="font-inter text-[10px] text-white/50 mt-0.5" data-id="element-345">
                ♥ {post.likes}
              </p>
            </div>

            {/* Instagram icon */}
            <div className="absolute top-3 right-3 opacity-30 group-hover:opacity-60 transition-opacity" data-id="element-346">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#C9A84C" strokeWidth="1.5" data-id="element-347">
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5" data-id="element-348" />
                <circle cx="12" cy="12" r="4" data-id="element-349" />
                <circle cx="17.5" cy="6.5" r="1" fill="#C9A84C" stroke="none" data-id="element-350" />
              </svg>
            </div>
          </motion.div>)}
      </div>

      {/* Live Indicator */}
      <LiveIndicator data-id="element-351" />
    </section>;
}
function LiveIndicator() {
  const [isLive] = useState(true);
  return <div className="max-w-7xl mx-auto px-6 mt-8" data-id="element-352">
      <motion.div initial={{
      opacity: 0,
      y: 12
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5
    }} className="flex items-center justify-between rounded-2xl px-5 py-4" style={{
      background: isLive ? 'rgba(220,38,38,0.06)' : 'rgba(255,255,255,0.03)',
      border: isLive ? '1px solid rgba(220,38,38,0.25)' : '1px solid #2A2622'
    }} data-id="element-353">
        <div className="flex items-center gap-4" data-id="element-354">
          {/* Pulsing dot */}
          <div className="relative flex-shrink-0" data-id="element-355">
            {isLive && <motion.div className="absolute inset-0 rounded-full" style={{
            background: 'rgba(220,38,38,0.4)'
          }} animate={{
            scale: [1, 2.2, 1],
            opacity: [0.6, 0, 0.6]
          }} transition={{
            duration: 1.6,
            repeat: Infinity,
            ease: 'easeOut'
          }} data-id="element-356" />}
            <div className="w-3 h-3 rounded-full relative z-10" style={{
            background: isLive ? '#dc2626' : '#444'
          }} data-id="element-357" />
          </div>

          <div data-id="element-358">
            <div className="flex items-center gap-2" data-id="element-359">
              <span className="font-montserrat font-black text-xs tracking-widest" style={{
              color: isLive ? '#dc2626' : '#666'
            }} data-id="element-360">
                {isLive ? 'LIVE NOW' : 'OFFLINE'}
              </span>
              {isLive && <motion.span animate={{
              opacity: [1, 0.3, 1]
            }} transition={{
              duration: 1.4,
              repeat: Infinity
            }} className="font-montserrat text-[8px] tracking-widest text-white/30 border border-white/10 rounded px-1.5 py-0.5" data-id="element-361">
                  ON AIR
                </motion.span>}
            </div>
            <p className="font-inter font-light text-xs text-white/50 mt-0.5" data-id="element-362">
              {isLive ? 'MK Lounge on U is streaming live — join the party' : 'MK Lounge on U — next live stream coming soon'}
            </p>
          </div>
        </div>

        {isLive && <motion.a href="https://instagram.com/mk_on_u" target="_blank" rel="noopener noreferrer" whileTap={{
        scale: 0.96
      }} className="flex-shrink-0 font-montserrat font-black text-[10px] tracking-widest px-4 py-2.5 rounded-xl transition-all duration-300" style={{
        background: '#dc2626',
        color: '#fff',
        boxShadow: '0 4px 16px rgba(220,38,38,0.35)'
      }} data-id="element-363">
            WATCH LIVE
          </motion.a>}
      </motion.div>
    </div>;
}